import { render, staticRenderFns } from "./SinglePost.vue?vue&type=template&id=367841dd&v-if=singleArticle&"
import script from "./SinglePost.vue?vue&type=script&lang=js&"
export * from "./SinglePost.vue?vue&type=script&lang=js&"
import style0 from "./SinglePost.vue?vue&type=style&index=0&id=367841dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports